import Axios from 'axios'
import {useMutation} from '@tanstack/react-query'
import {SubmitValues} from '../tripShareTypes'

const postTrip = async (tripShareValues: SubmitValues) => {
  const {data} = await Axios.post(`/TripShare`, tripShareValues)
  return data
}

export function useTripShareModal() {
  return useMutation(postTrip, {})
}
